import React from 'react';
import { IconProps } from './types/Icon.type';

function QuoteStartIcon(props: IconProps) {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 14C7 14.5523 7.44772 15 8 15H13.4842C14.0365 15 14.4842 14.5523 14.4842 14V8.88991C14.4842 8.33762 14.0365 7.88991 13.4842 7.88991H12.0737C11.5214 7.88991 11.0607 7.43732 11.1689 6.89573C11.4777 5.34864 12.5271 4.2044 14.154 3.77885C14.6542 3.64801 15.0526 3.22808 15.0526 2.71105V1.08315C15.0526 0.499442 14.5521 0.0348305 13.9778 0.139542C9.49017 0.957861 7 4.52606 7 9.08257V14ZM16.9474 14C16.9474 14.5523 17.3951 15 17.9474 15H23.4316C23.9839 15 24.4316 14.5523 24.4316 14V8.88991C24.4316 8.33762 23.9839 7.88991 23.4316 7.88991H22.0211C21.4688 7.88991 21.0081 7.43732 21.1162 6.89573C21.4251 5.34864 22.4745 4.2044 24.1014 3.77885C24.6016 3.64801 25 3.22808 25 2.71105V1.08315C25 0.499442 24.4995 0.0348305 23.9252 0.139542C19.4375 0.957861 16.9474 4.52606 16.9474 9.08257V14Z"
        fill="#EFEFEF"
      />
    </svg>
  );
}

export default QuoteStartIcon;
